module.exports = __webpack_public_path__ + "img/comp-onion.54cf4117.svg";